<main>
    <div class="version1" 
        *ngIf="version === 1"
        (click)="changeVersion(2)">
        <div class="call">
            <div>Rappelez<br>moi</div>
            <img src="./../../../assets/logo-tel-blanc.png" alt="logo-tel">
        </div>

        <div class="vagues">
            <span></span>
            <span></span>
        </div>
    </div>

    <div 
        class="version2" 
        *ngIf="version === 2">
        <div class="x" (click)="changeVersion(1)"> X </div>
        <input placeholder="n°tel ici" type="text" name="tel" id="rappel-tel" [(ngModel)]="tel" />
        <input placeholder="Votre email" type="text" name="email" id="email" [(ngModel)]="email"/>
        <div (click)="changeVersion(3)">Rappelez-moi</div>
    </div>

    <div class="version3" *ngIf="version === 3">
        Nous vous rappelerons dans les plus brefs délais.
    </div>
</main>